// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
import store from '../../../src/store'
import { messageError } from '../../js/utils/utility.js'
var config = require('../../js/config.js')

var domainUrl = config.address
// var domainUrl = 'http://wms-test.geekuiot.com'
var headers = {
  'Content-Type': 'application/json'
}

// noPost请求
var noPost = function (url, data) {
  if (!data) {
    data = ''
  }

  return new Promise(function (resolve, reject) {
    axios({
      method: 'post',
      url: domainUrl + url,
      headers: headers,
      data: data
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        messageError('连接服务器失败，请重试！')
        reject(error)
      })
  })
}

// post请求
var post = function (url, data) {
  if (!data) {
    data = {}
  }
  data.user_id = store.state.eUserInfo.user_id

  return new Promise(function (resolve, reject) {
    axios({
      method: 'post',
      url: domainUrl + url,
      headers: headers,
      data: data
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        messageError('连接服务器失败，请重试！')
        reject(error)
      })
  })
}

export {
  noPost,
  post
}



//////////////////
// WEBPACK FOOTER
// ./static/Bookcase/js/request.js
// module id = ORmM
// module chunks = 1